<template>
  <div />
</template>

<script>
import classes from '~/config/classes'

/**
 * Vue: Venn accordion (venn-accordion)
 * -----------------------------------------------------------------------------
 * Accordion component used for Venn apps.
 * - Static section.
 *
 */

const selectors = {
  collapseBtn: '[js-venn-accordion="collapse-btn"]',
  accordionBody: '[js-venn-accordion="accordion-body"]',
}

export default {
  name: 'VennAccordion',

  props: {
    sectionId: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      collapseBtn: null,
      accordionBody: null,
    }
  },

  mounted() {
    this.setNodeSelectors()
    this.setEventListeners()
  },

  methods: {

    /**
     * Set node selectors.
     */
    setNodeSelectors() {
      const sectionElement = document.getElementById(`VennAccordion--${this.sectionId}`)

      this.collapseBtn =
        [...sectionElement.querySelectorAll(selectors.collapseBtn)]

      this.accordionBody =
        [...sectionElement.querySelectorAll(selectors.accordionBody)]
    },

    /**
     * Set event listeners for accordion.
     */
    setEventListeners() {
      this.collapseBtn.forEach((element, index) => {
        element.addEventListener('click', () => this.toggleAccordion(index))
      })
    },

    /**
     * Toggle accordion.
     * @param {Number} index - Index of the accordion item.
     */
    toggleAccordion(index) {
      this.accordionBody[index].classList.toggle(classes.hidden)
      this.collapseBtn[index].classList.toggle(classes.active)
    },
  },
}
</script>

<style lang="scss">
@import './venn-accordion';
</style>
